export default function (state, payload) {
  return {
    ...state,
    matchingAzubiIds: payload.matchingAzubiIds,
  }
}
